<form id="create-folder-dialog-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2>{{ 'dialog.create-folder.label.title' | translate }}</h2>
    <mat-error *ngIf="createFolderError">
        {{createFolderError}}
    </mat-error>
    <mat-form-field class="full-width-input">
        <input matInput type="text" placeholder="{{ 'dialog.create-folder.placeholder.folder-name' | translate }}"
            formControlName="folderName" required>
        <mat-error *ngIf="formSubmitAttempt">
            {{ 'dialog.create-folder.error.invalid-folder-name' | translate }}
        </mat-error>
    </mat-form-field>
    <button id="create-folder-button" mat-raised-button color="primary">{{ 'general.button.save' | translate | uppercase }}</button>
</form>